import { type InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/cn';

interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { className, label, checked, id, ...rest },
  ref
) {
  const sid = id || `sw-${Math.random().toString(36).slice(2, 8)}`;
  return (
    <label
      htmlFor={sid}
      className={cn(
        'inline-flex items-center gap-3 cursor-pointer select-none',
        rest.disabled && 'cursor-not-allowed opacity-60'
      )}
    >
      <span
        className={cn(
          'relative inline-block w-9 h-5 rounded-full transition-colors',
          checked ? 'bg-brand-600' : 'bg-slate-300',
          className
        )}
      >
        <input
          id={sid}
          ref={ref}
          type="checkbox"
          checked={checked}
          className="absolute inset-0 opacity-0 cursor-pointer"
          {...rest}
        />
        <span
          aria-hidden="true"
          className={cn(
            'absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform',
            checked && 'translate-x-4'
          )}
        />
      </span>
      {label && <span className="text-sm text-slate-700">{label}</span>}
    </label>
  );
});
